import type { HomeDashboardProps } from './components/HomeDashboard';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PlacesPeople" */ './lazyIndex'),
    { name: 'PlacesPeople' }
);

const lazyLoadPlacesPeopleModule = new LazyImport(lazyModule, m => m);

export function loadPlacesPeopleModule(): Promise<typeof lazyIndex> {
    return lazyLoadPlacesPeopleModule.import();
}

export const HomeDashboard: LazyComponent<HomeDashboardProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.HomeDashboard
);

export const HybridspaceHomeDashboardContent: LazyComponent<{}, unknown, void> =
    createLazyComponent(lazyModule, m => m.HybridspaceHomeDashboardContent);
